import { render, staticRenderFns } from "./order-detail-view.vue?vue&type=template&id=166a9a0b"
import script from "./order-detail-view.vue?vue&type=script&lang=js"
export * from "./order-detail-view.vue?vue&type=script&lang=js"
import style0 from "./order-detail-view.vue?vue&type=style&index=0&id=166a9a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports